import Palette from '@naruto/bgdapp/src/base/theme/normal/default/Global/Palette';

export default {
  MuiSnackbarContent: {
    styleOverrides: {
      root: {
        minWidth: 'auto !important',
        background: Palette.background.paper
      },
      message: {
        padding: '4px 0px'
      }
    }
  }
};
